<div class="step-content">
  <app-dashboard-box [title]="'Alarmverwaltung'"
                     class="transparent filter"
                     icon="filter_alt">

    <section class="filter-section">
      <app-input-select [formData]="userFilterConfig" />
      <app-input-select [formData]="actionFilterConfig" />
      <app-input-select [formData]="targetFilterConfig" />

      @if (tagetFilter == LoggingTargetEnum.DEVICE) {
        <app-input-select [formData]="deviceFilterConfig" />
      } @else {
        <div class="spacer"></div>
      }
    </section>
  </app-dashboard-box>

  <app-dashboard-box [buttonLabel]="cuntLabel"
                     [title]="'Loglist'"
                     icon="list">
    <app-table [tableConfig]="tableConfig"
               [tableRows]="tableRows"
               [loading]="loading" />
  </app-dashboard-box>
</div>
